<template>
	<div id="chooseContact">
		<el-table :data="tableData" stripe style="width: 100%"
			:header-cell-style="{background:'#ECECEF',color:'#909399'}">
			<el-table-column prop="name" label="姓名">
			</el-table-column>
			<el-table-column prop="id_card" label="身份证"></el-table-column>
			<el-table-column prop="account" label="卡号"></el-table-column>
			<el-table-column prop="bank" label="银行"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<span class="col-text point" @click="yes(scope.row)"><i class="el-icon-zoom-in pr2"></i>选择</span>
					<span class="col-text point pl10" @click="openAddBank(scope.row)"><i class="el-icon-setting pr2"></i>编辑</span>
				</template>
			</el-table-column>
		</el-table>
		
		<div class="ta-r pt10">
			<el-button size="small" style="background-color: #ffffff; padding: 10px 35px" class="fs14" icon="el-icon-circle-plus"
				@click="openAddBank()">新增银行账户</el-button>
		</div>

		<my-dialog :title="addDialogTitle" path="contribution/bank/addbank.vue" ref="addBank" width="600px" yes
			@ok="afterAddBank"></my-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addDialogTitle: "添加银行账户",
				tableData: []
			};
		},
		methods: {
			init() {
				this.$api.member
					.MyInfo()
					.then((res) => {
						console.log('myinfo res', res);
						this.tableData = res.List;
					})
					.catch((res) => {});
			},

			// 展示新增银行弹层
			openAddBank(memberBank) {
				this.addDialogTitle = memberBank === undefined ? "新增银行账户" : "编辑银行账户";
				this.$refs.addBank.show(memberBank);
			},
			afterAddBank() {
				this.init();
			},
			yes(chooseBank) {
				this.$emit("ok", chooseBank);
				this.$emit("hide");
			},
		},
	};
</script>

<style lang="scss" scoped>
	.col-text {
		color: #5090f0;
	}

	.el-table {
		border-left: 1px solid #ececef;
		border-right: 1px solid #ececef;

		.el-table td,
		.el-table th {
			padding: 7px 0 !important;
		}
	}

	.el-table .caret-wrapper {
		height: 23px;

		.sort-caret.ascending {
			top: 0px;
		}

		.sort-caret.descending {
			bottom: 1px;
		}
	}

	thead th {
		padding: 4px !important;
	}
</style>
